export const Homepage = () => {
  return <h1 className="title">Home Page</h1>;
};
